import { render, staticRenderFns } from "./activityPreview.vue?vue&type=template&id=23484dbe"
import script from "./activityPreview.vue?vue&type=script&lang=js"
export * from "./activityPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports